export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-film-line' },
  { id: 'drama', name: '短剧', slug: 'drama', icon: 'ri-clapperboard-line' },
  { id: 'movie', name: '电影', slug: 'movie', icon: 'ri-movie-line' },
  { id: 'variety', name: '综艺', slug: 'variety', icon: 'ri-tv-line' },
  { id: 'anime', name: '动漫', slug: 'anime', icon: 'ri-emotion-line' },
  { id: 'documentary', name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { id: 'music', name: '音乐', slug: 'music', icon: 'ri-music-line' },
  { id: 'lifestyle', name: '生活', slug: 'lifestyle', icon: 'ri-heart-line' },
];

export const videos = [
  {
    id: 'v001',
    title: '都市恋爱物语·第一季',
    category: 'drama',
    description: '繁华都市中，一群年轻人的爱情与梦想交织的故事。从陌生到熟悉，从相爱到相守，每一个瞬间都值得被铭记。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20romantic%20urban%20drama%20poster%2C%20young%20couple%20in%20city%20at%20sunset%2C%20warm%20cinematic%20lighting%2C%20emotional%20atmosphere%2C%20Chinese%20drama%20aesthetic%2C%20soft%20bokeh%20background%2C%20editorial%20film%20poster%20style&width=800&height=450&seq=video-thumb-001&orientation=landscape',
    duration: '45:20',
    views: 1280000,
    updateDate: '2026-08-06',
    rating: 9.2,
    episodes: 24,
    isHot: true,
    isNew: false,
    tags: ['都市', '恋爱', '青春'],
  },
  {
    id: 'v002',
    title: '古剑传说·仙侠篇',
    category: 'drama',
    description: '上古神剑重现人间，少年剑客踏上修仙之路。恩怨情仇，正邪较量，一部波澜壮阔的仙侠史诗。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20with%20ancient%20sword%20and%20martial%20arts%20hero%2C%20misty%20mountains%2C%20traditional%20Chinese%20ink%20wash%20painting%20style%2C%20ethereal%20atmosphere%2C%20wuxia%20aesthetic&width=800&height=450&seq=video-thumb-002&orientation=landscape',
    duration: '52:10',
    views: 2560000,
    updateDate: '2026-08-05',
    rating: 9.5,
    episodes: 36,
    isHot: true,
    isNew: false,
    tags: ['仙侠', '古装', '玄幻'],
  },
  {
    id: 'v003',
    title: '极限挑战·荒野求生',
    category: 'variety',
    description: '六位明星嘉宾被空投到无人荒岛，在极限环境下展开七天生存挑战。真实、刺激、爆笑不断。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20wilderness%20survival%20poster%2C%20celebrities%20on%20tropical%20island%2C%20adventure%20and%20challenge%20theme%2C%20bright%20natural%20lighting%2C%20energetic%20atmosphere&width=800&height=450&seq=video-thumb-003&orientation=landscape',
    duration: '90:00',
    views: 3890000,
    updateDate: '2026-08-04',
    rating: 9.0,
    episodes: 12,
    isHot: true,
    isNew: true,
    tags: ['户外', '挑战', '明星'],
  },
  {
    id: 'v004',
    title: '深海迷踪',
    category: 'movie',
    description: '深海科考队在一次例行任务中意外发现神秘海底遗迹，随之而来的是令人窒息的深海恐怖与未知生物的追杀。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20thriller%20movie%20poster%2C%20deep%20ocean%20with%20mysterious%20glowing%20ruins%2C%20suspenseful%20atmosphere%2C%20dark%20blue%20tones%2C%20cinematic%20underwater%20scene%2C%20dramatic%20lighting&width=800&height=450&seq=video-thumb-004&orientation=landscape',
    duration: '118:00',
    views: 4520000,
    updateDate: '2026-08-03',
    rating: 8.8,
    episodes: 0,
    isHot: false,
    isNew: true,
    tags: ['科幻', '悬疑', '深海'],
  },
  {
    id: 'v005',
    title: '星空下的约定',
    category: 'anime',
    description: '两个来自不同世界的少年，在星空下许下约定。穿越时空的奇幻冒险，关于友情与勇气的温暖故事。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20starry%20night%20sky%20and%20two%20young%20characters%2C%20dreamy%20fantasy%20atmosphere%2C%20soft%20pastel%20colors%2C%20whimsical%20animation%20style%2C%20emotional%20and%20warm&width=800&height=450&seq=video-thumb-005&orientation=landscape',
    duration: '24:30',
    views: 1980000,
    updateDate: '2026-08-02',
    rating: 9.3,
    episodes: 12,
    isHot: true,
    isNew: false,
    tags: ['奇幻', '冒险', '友情'],
  },
  {
    id: 'v006',
    title: '舌尖上的家乡味',
    category: 'documentary',
    description: '走遍中国大江南北，探寻各地最地道的家乡味道。每一道菜背后，都是一段关于家的记忆与情怀。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20traditional%20Chinese%20cuisine%20on%20wooden%20table%2C%20steaming%20hot%20dishes%2C%20warm%20kitchen%20lighting%2C%20rustic%20and%20homey%20atmosphere%2C%20appetizing%20food%20photography&width=800&height=450&seq=video-thumb-006&orientation=landscape',
    duration: '35:00',
    views: 870000,
    updateDate: '2026-08-01',
    rating: 9.6,
    episodes: 10,
    isHot: false,
    isNew: false,
    tags: ['美食', '文化', '旅行'],
  },
  {
    id: 'v007',
    title: '逆袭人生·职场风云',
    category: 'drama',
    description: '普通白领如何在职场中逆袭成长，面对办公室政治、商业竞争与个人情感的考验，一步步走向人生巅峰。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20office%20drama%20poster%2C%20young%20professional%20in%20modern%20skyscraper%20office%2C%20city%20skyline%20through%20window%2C%20professional%20atmosphere%2C%20warm%20sunset%20lighting&width=800&height=450&seq=video-thumb-007&orientation=landscape',
    duration: '48:00',
    views: 2150000,
    updateDate: '2026-07-30',
    rating: 8.9,
    episodes: 30,
    isHot: true,
    isNew: false,
    tags: ['都市', '职场', '励志'],
  },
  {
    id: 'v008',
    title: '欢乐喜剧人·2026',
    category: 'variety',
    description: '全国顶尖喜剧人同台竞技，爆笑小品、脱口秀、即兴表演轮番上阵。笑料不断，欢乐不停。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20poster%2C%20comedians%20on%20stage%20with%20colorful%20spotlights%2C%20laughing%20and%20energetic%20atmosphere%2C%20bright%20theatrical%20lighting%2C%20entertaining%20show&width=800&height=450&seq=video-thumb-008&orientation=landscape',
    duration: '85:00',
    views: 5100000,
    updateDate: '2026-07-28',
    rating: 9.1,
    episodes: 12,
    isHot: true,
    isNew: true,
    tags: ['喜剧', '搞笑', '竞技'],
  },
  {
    id: 'v009',
    title: '暗夜追踪',
    category: 'movie',
    description: '退休刑警为查明十年前未破悬案，独自踏上追踪真相之路。黑暗中的正义，永不缺席。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20detective%20in%20rainy%20night%20city%20alley%2C%20noir%20cinematic%20style%2C%20dark%20moody%20atmosphere%2C%20suspenseful%20lighting%2C%20film%20noir%20aesthetic&width=800&height=450&seq=video-thumb-009&orientation=landscape',
    duration: '125:00',
    views: 3280000,
    updateDate: '2026-07-25',
    rating: 9.0,
    episodes: 0,
    isHot: false,
    isNew: false,
    tags: ['犯罪', '悬疑', '剧情'],
  },
  {
    id: 'v010',
    title: '萌宠乐园大冒险',
    category: 'anime',
    description: '一群可爱的小动物在神奇的萌宠乐园中展开冒险，关于勇气、友谊与成长的有趣故事。适合全家观看。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cute%20anime%20poster%20with%20adorable%20animals%20in%20colorful%20amusement%20park%2C%20bright%20and%20cheerful%20style%2C%20children%20animation%20aesthetic%2C%20playful%20atmosphere&width=800&height=450&seq=video-thumb-010&orientation=landscape',
    duration: '20:00',
    views: 1560000,
    updateDate: '2026-07-22',
    rating: 9.4,
    episodes: 26,
    isHot: false,
    isNew: false,
    tags: ['萌宠', '冒险', '儿童'],
  },
  {
    id: 'v011',
    title: '华语金曲盛典',
    category: 'music',
    description: '汇聚华语乐坛最顶尖歌手，经典金曲与全新创作交织，一场不容错过的音乐盛宴。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20music%20concert%20poster%2C%20grand%20stage%20with%20dramatic%20spotlight%20and%20singer%2C%20passionate%20performance%20atmosphere%2C%20golden%20and%20red%20tones%2C%20spectacular%20lighting&width=800&height=450&seq=video-thumb-011&orientation=landscape',
    duration: '120:00',
    views: 6780000,
    updateDate: '2026-07-20',
    rating: 9.3,
    episodes: 8,
    isHot: true,
    isNew: false,
    tags: ['音乐', '演唱会', '华语'],
  },
  {
    id: 'v012',
    title: '田园时光·慢生活',
    category: 'lifestyle',
    description: '逃离城市喧嚣，回归田园生活。种菜、养花、做饭，感受最纯粹的慢生活美好。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20countryside%20lifestyle%20poster%2C%20peaceful%20rural%20garden%20with%20flowers%20and%20vegetables%2C%20warm%20sunlight%2C%20natural%20and%20simple%20living%20aesthetic%2C%20cozy%20cottage%20atmosphere&width=800&height=450&seq=video-thumb-012&orientation=landscape',
    duration: '28:00',
    views: 940000,
    updateDate: '2026-07-18',
    rating: 9.1,
    episodes: 20,
    isHot: false,
    isNew: false,
    tags: ['田园', '生活', '慢生活'],
  },
  {
    id: 'v013',
    title: '极地·最后的净土',
    category: 'documentary',
    description: '深入北极圈，记录极地生态与野生动物的真实生活。在气候变化的今天，这片最后的净土何去何从。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20nature%20documentary%20poster%2C%20arctic%20landscape%20with%20polar%20bear%20and%20aurora%2C%20majestic%20frozen%20wilderness%2C%20cold%20blue%20and%20white%20tones%2C%20epic%20cinematic%20nature%20photography&width=800&height=450&seq=video-thumb-013&orientation=landscape',
    duration: '50:00',
    views: 1230000,
    updateDate: '2026-07-15',
    rating: 9.7,
    episodes: 6,
    isHot: false,
    isNew: false,
    tags: ['自然', '极地', '环保'],
  },
  {
    id: 'v014',
    title: '恋恋笔记本',
    category: 'movie',
    description: '两个年轻人在大学图书馆偶然相遇，一本笔记本串联起他们跨越十年的爱情故事。温暖治愈的青春爱情电影。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20youth%20movie%20poster%2C%20young%20couple%20in%20university%20library%2C%20soft%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20sweet%20and%20tender%20romance%2C%20autumn%20tones&width=800&height=450&seq=video-thumb-014&orientation=landscape',
    duration: '110:00',
    views: 2850000,
    updateDate: '2026-07-12',
    rating: 8.7,
    episodes: 0,
    isHot: false,
    isNew: false,
    tags: ['爱情', '青春', '治愈'],
  },
  {
    id: 'v015',
    title: '潮流音乐榜·2026',
    category: 'music',
    description: '盘点2026年最热门华语歌曲，每周更新榜单。从流行到独立，从嘻哈到民谣，总有一首打动你。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20music%20chart%20poster%2C%20modern%20music%20studio%20with%20colorful%20neon%20lights%2C%20trendy%20urban%20style%2C%20dynamic%20and%20energetic%20atmosphere%2C%20music%20visualization&width=800&height=450&seq=video-thumb-015&orientation=landscape',
    duration: '60:00',
    views: 3450000,
    updateDate: '2026-07-10',
    rating: 8.5,
    episodes: 24,
    isHot: false,
    isNew: false,
    tags: ['音乐', '榜单', '流行'],
  },
  {
    id: 'v016',
    title: '居家美食日记',
    category: 'lifestyle',
    description: '每天一道家常菜，从食材选购到烹饪技巧，手把手教你做出餐厅级美味。简单易学，好吃不贵。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20home%20cooking%20poster%2C%20delicious%20homemade%20dishes%20in%20cozy%20kitchen%2C%20warm%20natural%20light%2C%20appetizing%20food%20styling%2C%20comfortable%20home%20atmosphere&width=800&height=450&seq=video-thumb-016&orientation=landscape',
    duration: '22:00',
    views: 760000,
    updateDate: '2026-07-08',
    rating: 9.0,
    episodes: 36,
    isHot: false,
    isNew: false,
    tags: ['美食', '家常', '教程'],
  },
];